import http from "@/shared/axios-config/g-http-metodos";

function GetDevolucoesByFiltro(filtros) {
    const { res, erro, requisicao } = http.postArray('devolucoes/GetDevolucoesByFiltro', filtros)
    return { DevolucoesArray: res , erro, requisicao }
}

function GetStatusDevolucoes(){
    const { res, erro, requisicao } = http.getArray("devolucoes/GetStatusDevolucoes");
    return { StatusArray: res, erro, requisicao }
}
  

const DevolucoesController = {
    GetDevolucoesByFiltro,
    GetStatusDevolucoes
}

export default DevolucoesController;